import React, { useState } from 'react';
import { Plus, X, Trash2 } from 'lucide-react';
import { COLORS } from '../../../../utils/constants';

const tagColors = {
  VIP: COLORS.primary,
  Whale: '#3b82f6',
  Active: COLORS.success,
  Inactive: '#6b7280',
  New: '#8b5cf6',
  Problem: COLORS.danger,
  Potential: '#06b6d4',
  Referral: '#ec4899',
  Bonus: '#14b8a6',
};

const ClientTagsSection = ({ predefinedTags, setPredefinedTags, onSaveTags }) => {
  const [newTag, setNewTag] = useState('');
  const [newTagColor, setNewTagColor] = useState(COLORS.primary);

  const addTag = () => {
    if (newTag.trim() && !predefinedTags.find(t => t.name === newTag.trim())) {
      setPredefinedTags([...predefinedTags, { name: newTag.trim(), color: newTagColor }]);
      setNewTag('');
    }
  };

  const removeTag = (tagName) => {
    setPredefinedTags(predefinedTags.filter(t => t.name !== tagName));
  };

  const colorOptions = [
    COLORS.primary, COLORS.success, COLORS.danger, '#3b82f6', 
    '#8b5cf6', '#06b6d4', '#ec4899', '#14b8a6', '#6b7280'
  ];

  return (
    <div style={{
      backgroundColor: COLORS.card,
      borderRadius: '12px',
      padding: '20px',
      border: `1px solid ${COLORS.border}`,
      marginBottom: '16px',
    }}>
      <h3 style={{ color: COLORS.text, fontSize: '16px', fontWeight: '600', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ 
          width: '20px', 
          height: '20px', 
          borderRadius: '50%', 
          background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.success})`,
        }} />
        Теги клиентов
      </h3>
      
      {/* Existing tags */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '16px' }}>
        {predefinedTags.map(tag => (
          <div key={tag.name} style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 12px',
            backgroundColor: `${tagColors[tag.name] || tag.color || COLORS.primary}20`,
            borderRadius: '20px',
            border: `1px solid ${tagColors[tag.name] || tag.color || COLORS.primary}40`,
          }}>
            <span style={{ 
              color: tagColors[tag.name] || tag.color || COLORS.primary, 
              fontSize: '13px',
              fontWeight: '500',
            }}>
              {tag.name}
            </span>
            <button
              onClick={() => removeTag(tag.name)}
              style={{ 
                background: 'none', 
                border: 'none', 
                color: tagColors[tag.name] || tag.color || COLORS.primary, 
                cursor: 'pointer', 
                padding: 0,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <X size={14} />
            </button>
          </div>
        ))}
      </div>
      
      {/* Add new tag */}
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <input
          type="text"
          value={newTag}
          onChange={(e) => setNewTag(e.target.value)}
          placeholder="Новый тег..."
          onKeyPress={(e) => e.key === 'Enter' && addTag()}
          style={{
            flex: 1,
            padding: '10px 12px',
            backgroundColor: COLORS.background,
            border: `1px solid ${COLORS.border}`,
            borderRadius: '8px',
            color: COLORS.text,
            fontSize: '14px',
          }}
        />
        
        {/* Color picker */}
        <div style={{ display: 'flex', gap: '4px' }}>
          {colorOptions.map(color => (
            <button
              key={color}
              onClick={() => setNewTagColor(color)}
              style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                backgroundColor: color,
                border: newTagColor === color ? '2px solid #fff' : 'none',
                boxShadow: newTagColor === color ? `0 0 0 2px ${color}` : 'none',
                cursor: 'pointer',
              }}
            />
          ))}
        </div>
        
        <button
          onClick={addTag}
          style={{
            padding: '10px 16px',
            backgroundColor: COLORS.primary,
            border: 'none',
            borderRadius: '8px',
            color: '#000',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
          }}
        >
          <Plus size={16} /> Добавить
        </button>
      </div>
      
      {/* Save button */}
      <button
        onClick={onSaveTags}
        style={{
          marginTop: '16px',
          padding: '10px 20px',
          backgroundColor: COLORS.success,
          border: 'none',
          borderRadius: '8px',
          color: '#fff',
          fontWeight: '600',
          cursor: 'pointer',
          width: '100%',
        }}
      >
        Сохранить теги
      </button>
    </div>
  );
};

export default ClientTagsSection;
